import React from 'react';
import { LogoIconProps } from '../logo';

const MarkHyman = ({
  width = 257,
  className,
  color = 'var(--brand-950)',
  opacity = 0.5,
}: LogoIconProps): JSX.Element => (
  <svg
    width={width}
    viewBox='0 0 257 41'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <g clipPath='url(#clip0_19134_12240)'>
      <path
        d='M0.00870039 26.4158C0.035461 24.9693 0.180531 23.327 0.296024 21.8439L0.712926 1.34534H5.6425L15.5735 25.0087L24.9383 1.34534H29.727L30.4312 31.0636H25.6425L25.3594 6.41576L15.7721 30.9805C15.4298 31.4538 13.7819 31.0848 13.1735 31.2129L2.61433 6.41435L2.82701 31.0651H0.00870039C0.0298271 29.5172 -0.0194686 27.9622 0.00870039 26.4158Z'
        fill='white'
      />
      <path
        d='M0.00870039 26.4158C0.035461 24.9693 0.180531 23.327 0.296024 21.8439L0.712926 1.34534H5.6425L15.5735 25.0087L24.9383 1.34534H29.727L30.4312 31.0636H25.6425L25.3594 6.41576L15.7721 30.9805C15.4298 31.4538 13.7819 31.0848 13.1735 31.2129L2.61433 6.41435L2.82701 31.0651H0.00870039C0.0298271 29.5172 -0.0194686 27.9622 0.00870039 26.4158Z'
        fill={color}
        fillOpacity={opacity}
      />
      <path
        d='M125.075 40.5002L129.552 32.427L121.413 11.627H126.06L131.484 27.403L137.117 11.627H139.3L127.891 40.5002H125.075Z'
        fill='white'
      />
      <path
        d='M125.075 40.5002L129.552 32.427L121.413 11.627H126.06L131.484 27.403L137.117 11.627H139.3L127.891 40.5002H125.075Z'
        fill={color}
        fillOpacity={opacity}
      />
      <path
        d='M71.4155 0.500244V31.0636H67.1902V1.06362L70.7113 0.500244H71.4155Z'
        fill='white'
      />
      <path
        d='M71.4155 0.500244V31.0636H67.1902V1.06362L70.7113 0.500244H71.4155Z'
        fill={color}
        fillOpacity={opacity}
      />
      <path
        d='M256.479 28.3875V31.3453C255.918 33.6664 254.896 35.5918 253.031 37.1228C250.021 39.596 245.472 39.0199 241.831 39.0918V21.0636C246.98 20.9537 253.827 20.8101 255.98 26.5622L256.479 28.3875ZM244.648 38.1059H247.958C248.259 38.1059 249.528 37.527 249.863 37.3354C253.378 35.3298 254.083 30.3171 252.993 26.7312C251.811 22.8453 248.344 21.9481 244.647 21.9087V38.1059H244.648Z'
        fill='white'
      />
      <path
        d='M256.479 28.3875V31.3453C255.918 33.6664 254.896 35.5918 253.031 37.1228C250.021 39.596 245.472 39.0199 241.831 39.0918V21.0636C246.98 20.9537 253.827 20.8101 255.98 26.5622L256.479 28.3875ZM244.648 38.1059H247.958C248.259 38.1059 249.528 37.527 249.863 37.3354C253.378 35.3298 254.083 30.3171 252.993 26.7312C251.811 22.8453 248.344 21.9481 244.647 21.9087V38.1059H244.648Z'
        fill={color}
        fillOpacity={opacity}
      />
      <path
        d='M99.3014 1.34534V14.8665H113.527V1.34534H118.314V31.0636H113.527V16.5566H99.3014V31.0636H94.5127V1.34534H99.3014Z'
        fill='white'
      />
      <path
        d='M99.3014 1.34534V14.8665H113.527V1.34534H118.314V31.0636H113.527V16.5566H99.3014V31.0636H94.5127V1.34534H99.3014Z'
        fill={color}
        fillOpacity={opacity}
      />
      <path
        d='M145.638 15.289C148.214 12.7791 149.996 10.4157 154.04 11.465C156.189 12.0228 156.545 13.2397 157.185 15.0834C157.383 15.6566 157.489 15.0538 157.672 14.8636C160.117 12.3341 162.109 10.2749 165.996 11.6214C167.618 12.1834 168.878 14.0834 168.878 15.7819V31.0636H164.793C164.642 27.0425 164.992 22.8805 164.799 18.8749C164.771 18.2805 164.714 17.3467 164.637 16.7834C164.116 12.9622 159.402 13.9805 157.328 15.9228V31.0636H153.103V16.627C153.103 16.5538 152.806 15.7214 152.737 15.5848C151.533 13.1946 147.3 14.2974 145.779 15.9228V31.0636H141.554V12.0496L145.638 11.4862V15.289Z'
        fill='white'
      />
      <path
        d='M145.638 15.289C148.214 12.7791 149.996 10.4157 154.04 11.465C156.189 12.0228 156.545 13.2397 157.185 15.0834C157.383 15.6566 157.489 15.0538 157.672 14.8636C160.117 12.3341 162.109 10.2749 165.996 11.6214C167.618 12.1834 168.878 14.0834 168.878 15.7819V31.0636H164.793C164.642 27.0425 164.992 22.8805 164.799 18.8749C164.771 18.2805 164.714 17.3467 164.637 16.7834C164.116 12.9622 159.402 13.9805 157.328 15.9228V31.0636H153.103V16.627C153.103 16.5538 152.806 15.7214 152.737 15.5848C151.533 13.1946 147.3 14.2974 145.779 15.9228V31.0636H141.554V12.0496L145.638 11.4862V15.289Z'
        fill={color}
        fillOpacity={opacity}
      />
      <path
        d='M208.593 31.0636H204.368V17.472C204.368 17.2354 204.065 16.1974 203.948 15.9199C202.79 13.1622 197.717 14.1509 196.058 16.0636V31.0636H191.833V12.0495L195.917 11.4861V15.4298C197.434 14.1495 199.009 12.1213 200.987 11.5565C204.611 10.5213 208.593 12.1044 208.593 16.3453V31.0636Z'
        fill='white'
      />
      <path
        d='M208.593 31.0636H204.368V17.472C204.368 17.2354 204.065 16.1974 203.948 15.9199C202.79 13.1622 197.717 14.1509 196.058 16.0636V31.0636H191.833V12.0495L195.917 11.4861V15.4298C197.434 14.1495 199.009 12.1213 200.987 11.5565C204.611 10.5213 208.593 12.1044 208.593 16.3453V31.0636Z'
        fill={color}
        fillOpacity={opacity}
      />
      <path
        d='M189.158 28.2468C189.262 28.3538 188.389 30.8397 188.237 31.058C188.017 31.3749 187.476 31.4468 187.113 31.4834C184.871 31.7045 182.62 30.6003 182.676 28.1059C181.368 29.7425 179.871 31.2397 177.661 31.4693C173 31.9538 171.368 28.0045 172.707 24.051L182.303 20.4777C182.479 20.4228 182.507 20.3144 182.538 20.1496C182.648 19.5679 182.589 17.3059 182.472 16.6904C181.768 12.9693 175.428 14.5439 173.1 15.7101C173.073 15.4594 173.25 15.2665 173.359 15.0552C173.626 14.5468 174.685 12.62 174.997 12.327C175.397 11.9524 176.617 11.6594 177.179 11.551C180.79 10.8566 186.341 11.2566 186.759 15.9242C187.058 19.258 186.268 23.7341 186.796 26.8735C187.016 28.182 187.981 28.3735 189.157 28.2453L189.158 28.2468ZM182.538 21.0637L176.768 23.6721C175.876 24.4228 176.248 27.42 176.876 28.3453C178.092 30.1355 181.519 29.1059 182.538 27.4721V21.0637Z'
        fill='white'
      />
      <path
        d='M189.158 28.2468C189.262 28.3538 188.389 30.8397 188.237 31.058C188.017 31.3749 187.476 31.4468 187.113 31.4834C184.871 31.7045 182.62 30.6003 182.676 28.1059C181.368 29.7425 179.871 31.2397 177.661 31.4693C173 31.9538 171.368 28.0045 172.707 24.051L182.303 20.4777C182.479 20.4228 182.507 20.3144 182.538 20.1496C182.648 19.5679 182.589 17.3059 182.472 16.6904C181.768 12.9693 175.428 14.5439 173.1 15.7101C173.073 15.4594 173.25 15.2665 173.359 15.0552C173.626 14.5468 174.685 12.62 174.997 12.327C175.397 11.9524 176.617 11.6594 177.179 11.551C180.79 10.8566 186.341 11.2566 186.759 15.9242C187.058 19.258 186.268 23.7341 186.796 26.8735C187.016 28.182 187.981 28.3735 189.157 28.2453L189.158 28.2468ZM182.538 21.0637L176.768 23.6721C175.876 24.4228 176.248 27.42 176.876 28.3453C178.092 30.1355 181.519 29.1059 182.538 27.4721V21.0637Z'
        fill={color}
        fillOpacity={opacity}
      />
      <path
        d='M222.889 21.0637L229.084 35.2905L234.72 21.0637H237.466C237.49 21.5989 237.431 22.1454 237.468 22.682C237.79 27.3539 237.607 32.082 237.742 36.7736C237.762 37.4778 238.183 38.4778 237.677 39.0919H235.072L234.789 24.3046L229.087 38.9525L227.53 39.1017L221.2 24.3032L221.411 38.7412L221.18 39.0736L219.579 39.0933L220.213 21.0637H222.889Z'
        fill='white'
      />
      <path
        d='M222.889 21.0637L229.084 35.2905L234.72 21.0637H237.466C237.49 21.5989 237.431 22.1454 237.468 22.682C237.79 27.3539 237.607 32.082 237.742 36.7736C237.762 37.4778 238.183 38.4778 237.677 39.0919H235.072L234.789 24.3046L229.087 38.9525L227.53 39.1017L221.2 24.3032L221.411 38.7412L221.18 39.0736L219.579 39.0933L220.213 21.0637H222.889Z'
        fill={color}
        fillOpacity={opacity}
      />
      <path
        d='M57.8943 15.2889C59.2816 13.6875 60.5915 11.2213 63.0352 11.2058C63.7281 11.2016 64.5183 11.6129 65.2183 11.627L64.0971 15.3692C63.8901 15.5157 61.9436 14.6861 61.4493 14.6199C60.0831 14.4382 59.0521 15.1143 58.0352 15.9213V31.0622H53.8098V12.0495L57.8943 11.4861V15.2889Z'
        fill='white'
      />
      <path
        d='M57.8943 15.2889C59.2816 13.6875 60.5915 11.2213 63.0352 11.2058C63.7281 11.2016 64.5183 11.6129 65.2183 11.627L64.0971 15.3692C63.8901 15.5157 61.9436 14.6861 61.4493 14.6199C60.0831 14.4382 59.0521 15.1143 58.0352 15.9213V31.0622H53.8098V12.0495L57.8943 11.4861V15.2889Z'
        fill={color}
        fillOpacity={opacity}
      />
      <path
        d='M82.9635 11.627L75.2353 18.8551L83.6677 31.0636H79.0903L72.1438 21.2974L79.5832 11.627H82.9635Z'
        fill='white'
      />
      <path
        d='M82.9635 11.627L75.2353 18.8551L83.6677 31.0636H79.0903L72.1438 21.2974L79.5832 11.627H82.9635Z'
        fill={color}
        fillOpacity={opacity}
      />
      <path
        d='M51.2747 28.2482L50.2198 31.2059C47.8198 32.1017 44.6845 31.0017 44.655 28.1074C44.3437 28.3454 44.1522 28.7876 43.8831 29.0947C39.393 34.1933 32.2409 30.7862 34.7986 24.0947L44.2789 20.4764C44.4578 20.4243 44.4859 20.3172 44.5183 20.1524C44.624 19.5947 44.5733 17.1327 44.4536 16.551C43.9 13.8566 39.9395 14.2285 37.9493 14.7102C36.9592 14.9496 36.0775 15.4496 35.0831 15.6454C35.6902 14.9102 36.4254 12.8172 37.0564 12.2679C37.2789 12.075 38.3634 11.7581 38.7127 11.6707C42.1127 10.8243 48.2817 11.1102 48.7409 15.6454C49.0803 19.0116 48.2085 23.6876 48.8043 26.8496C49.0719 28.2721 50.0029 28.3313 51.2761 28.251L51.2747 28.2482ZM44.655 21.0637L38.7451 23.675C38.1606 24.2158 38.2437 26.3693 38.3803 27.1271C38.9662 30.3651 43.124 29.513 44.655 27.4721V21.0637Z'
        fill='white'
      />
      <path
        d='M51.2747 28.2482L50.2198 31.2059C47.8198 32.1017 44.6845 31.0017 44.655 28.1074C44.3437 28.3454 44.1522 28.7876 43.8831 29.0947C39.393 34.1933 32.2409 30.7862 34.7986 24.0947L44.2789 20.4764C44.4578 20.4243 44.4859 20.3172 44.5183 20.1524C44.624 19.5947 44.5733 17.1327 44.4536 16.551C43.9 13.8566 39.9395 14.2285 37.9493 14.7102C36.9592 14.9496 36.0775 15.4496 35.0831 15.6454C35.6902 14.9102 36.4254 12.8172 37.0564 12.2679C37.2789 12.075 38.3634 11.7581 38.7127 11.6707C42.1127 10.8243 48.2817 11.1102 48.7409 15.6454C49.0803 19.0116 48.2085 23.6876 48.8043 26.8496C49.0719 28.2721 50.0029 28.3313 51.2761 28.251L51.2747 28.2482ZM44.655 21.0637L38.7451 23.675C38.1606 24.2158 38.2437 26.3693 38.3803 27.1271C38.9662 30.3651 43.124 29.513 44.655 27.4721V21.0637Z'
        fill={color}
        fillOpacity={opacity}
      />
    </g>
    <defs>
      <clipPath id='clip0_19134_12240'>
        <rect
          width='256.479'
          height='40'
          fill='white'
          transform='translate(0 0.500244)'
        />
      </clipPath>
    </defs>
  </svg>
);

export default MarkHyman;
